import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Import the i18n configuration
import GlobalErrorBoundary from './errors/GlobalErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalErrorBoundary>
        <App />
      </GlobalErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
